export function tourneyId() {
  const tourneyIds = [process.env.REACT_APP_YEAR];
  if (process.env.REACT_APP_ENVIRONMENT) {
    tourneyIds.push(process.env.REACT_APP_ENVIRONMENT);
  }
  return tourneyIds.join('-');
}
